import GeneratedUserStore from "./generated/GeneratedUserStore"

class UserStore extends GeneratedUserStore {

}

export const userStore = new UserStore()
